import { render, staticRenderFns } from "./MemberTransactionHistory.vue?vue&type=template&id=5a0ef74e&scoped=true&"
import script from "./MemberTransactionHistory.vue?vue&type=script&lang=js&"
export * from "./MemberTransactionHistory.vue?vue&type=script&lang=js&"
import style0 from "./MemberTransactionHistory.vue?vue&type=style&index=0&id=5a0ef74e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0ef74e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VCardTitle,VDataTable})
